import { render } from "./telephone.vue?vue&type=template&id=1fe47ec8&ts=true"
import script from "./telephone.vue?vue&type=script&lang=ts"
export * from "./telephone.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__